import { GridNode } from '../types';
import { getFuelIcon } from './fuelTypes';

/**
 * Single source of truth for the emoji/glyph shown for a grid node, used both
 * on DAG nodes and in the load-curve editor's source legend. Generators defer
 * to their fuel-type icon; other node types have a fixed glyph.
 */
export function getNodeIcon(node: GridNode): string {
  switch (node.type) {
    case 'generator': return getFuelIcon(node.fuelType);
    case 'load': return 'L';
    case 'bus': return 'B';
    case 'battery': return '🔋';
  }
}
